import { Phone } from "lucide-react";

const WhatsAppButton = () => {
  const message = encodeURIComponent("Hi, I'd like to know more about Sandhu Feeds products");

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <a
        href="tel:+917419900074"
        className="w-14 h-14 bg-[#2563EB] hover:bg-[#1d4ed8] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Call us"
      >
        <Phone className="w-7 h-7 text-white" />
      </a>
      <a
        href={`https://wa.me/917419900074?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-[#25D366] hover:bg-[#1ebe57] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Chat on WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.132 6.742 3.052 9.376L1.056 31.2l6.012-1.968A15.903 15.903 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.608c-.39 1.1-1.932 2.012-3.182 2.278-.856.18-1.974.324-5.738-1.234-4.818-1.994-7.916-6.878-8.156-7.196-.232-.318-1.934-2.576-1.934-4.914s1.224-3.486 1.658-3.964c.434-.478.948-.598 1.264-.598.316 0 .632.002.908.016.292.014.682-.11 1.066.814.39.94 1.326 3.236 1.442 3.47.116.234.194.506.038.814-.156.316-.234.512-.468.79-.234.276-.492.618-.702.828-.234.234-.478.488-.206.958.272.468 1.212 2 2.602 3.24 1.786 1.592 3.292 2.086 3.76 2.32.468.234.742.194 1.014-.118.272-.312 1.17-1.364 1.482-1.832.312-.468.624-.39 1.054-.234.434.156 2.724 1.286 3.192 1.52.468.234.78.35.896.546.116.194.116 1.138-.274 2.238z" />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppButton;
